import React, { useEffect, useState } from 'react';
import './contact_redesign.css';
import { addReachus, AppointReq } from '../Functions';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, useParams } from 'react-router-dom';
import { tags } from '../Data/metaTags';
import MetaTags from '../meta';
import insta from '../assets/icon/social/instagram_c.png';
import fb from '../assets/icon/social/facebook_c.png';
import pin from '../assets/icon/social/pinterest_c.png';
import twitter from '../assets/icon/social/twitter_c.png';
import yt from '../assets/icon/social/youtube_c.png';
import whatsapp from '../assets/icon/social/whatsapp_c.png';

const ReachUs = () => {
    const navigate = useNavigate();
    const { req } = useParams();
    const [formType, setFormType] = useState(req ? req : 'general');
    const [load, setLoad] = useState(false);

    useEffect(() => {
        if (req) {
            setFormType(req);
        }
        window.scrollTo(0, 0);
    }, [req]);

    const notify = () => toast.info("Thanks for reaching out. We will get back to you shortly.", {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light"
    });

    const addData = async () => {
        notify();
        setLoad(true);
        // This data object seems to be a placeholder in the original code. 
        // Ideally, we should capture real input values. For now, keeping logic consistent but improved UI.
        const data = {
            id: (new Date().getTime()).toString(),
            email: "raghavendra074743@gmail.com", // Keeping original placeholder logic
            des: "des.current.valu",
            phone: "",
            orders: "",
            name: "",
            organization: ""
        };
        console.log(data);
        const resp = await AppointReq(data);
        console.log("done", resp);
        setLoad(false);
        navigate("/");
    };

    const socialLinks = [
        { src: insta, link: "https://www.instagram.com/maviinci_in/" },
        { src: fb, link: "https://www.facebook.com/share/15DXLNZj4E/" },
        { src: pin, link: "https://in.pinterest.com/maviincifashion/" },
        { src: twitter, link: "https://x.com/maviincifashion?t=3Hy6jKr1NxuBUemXqMeYUA&s=08" },
        { src: yt, link: "https://www.youtube.com/@maviincifashion" },
        { src: whatsapp, link: "https://wa.me/918871081395" },
    ];

    return (
        <div className="contact-page">
            <MetaTags data={tags.reachus} />
            <ToastContainer
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />

            {/* Section 1: Header */}
            <header className="contact-header">
                <h1 className="contact-title">{tags.reachus.h1}</h1>
                <p className="contact-subtitle">{tags.reachus.p}</p>
            </header>

            <div className="contact-container">
                {/* Section 2: Contact Info (Left) */}
                <div className="contact-info-card">
                    <div className="info-item">
                        <div className="info-label">Address</div>
                        <div className="info-value">
                            Blue Pearl Industries Inc.<br />
                            Ward 15 Indira Para, Shanti Nagar<br />
                            Bhilai, Durg, Chhattisgarh 490021<br />
                            India
                        </div>
                    </div>

                    <div className="info-item">
                        <div className="info-label">Contact</div>
                        <div className="info-value">
                            isupport@bluepearlindustries.com<br />
                            +91-8871081395
                        </div>
                    </div>

                    <div className="info-item">
                        <div className="info-label">Follow Us</div>
                        <div className="social-links">
                            {socialLinks.map((val, index) => (
                                <a href={val.link} key={index} target="_blank" rel="noreferrer" className="social-icon">
                                    <img src={val.src} alt="Social" />
                                </a>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Section 3: Form (Right) */}
                <div className="contact-form-card">
                    <div className="form-header">
                        <h2 className="form-title">Send a Message</h2>
                        <select
                            className="form-select"
                            value={formType}
                            onChange={(e) => {
                                setFormType(e.target.value);
                                navigate(`/reachus/${e.target.value}`);
                            }}
                        >
                            <option value="general">General Inquiry</option>
                            <option value="getQuotation">Bulk Order Quote</option>
                            <option value="appointment">Schedule Appointment</option>
                        </select>
                    </div>

                    {formType === 'general' && (
                        <form className="contact-form">
                            <div className="form-group">
                                <input type="email" placeholder="Email Address *" className="form-input" required />
                            </div>
                            <div className="form-group">
                                <input type="tel" placeholder="Phone Number" className="form-input" />
                            </div>
                            <div className="form-group">
                                <textarea placeholder="How can we help you?" className="form-textarea" required></textarea>
                            </div>
                            <button className="submit-btn" type="button" onClick={addData}>
                                {load ? 'Sending...' : 'Submit Inquiry'}
                            </button>
                        </form>
                    )}

                    {formType === 'getQuotation' && (
                        <form className="contact-form">
                            <div className="form-group">
                                <input type="email" placeholder="Email Address *" className="form-input" required />
                            </div>
                            <div className="form-group">
                                <input type="text" placeholder="Company Name" className="form-input" />
                            </div>
                            <div className="form-group">
                                <input type="text" placeholder="Contact Person" className="form-input" />
                            </div>
                            <div className="form-group">
                                <input type="tel" placeholder="Phone Number" className="form-input" />
                            </div>
                            <div className="form-group">
                                <input type="number" placeholder="Approx. Quantity" className="form-input" />
                            </div>
                            <div className="form-group">
                                <textarea placeholder="Describe your requirements..." className="form-textarea" required></textarea>
                            </div>
                            <div className="form-group">
                                <label style={{ display: 'block', marginBottom: '0.5rem', color: '#6b7280' }}>Upload Reference Image</label>
                                <input type='file' multiple className="form-input" style={{ padding: '0.5rem' }} />
                            </div>
                            <button className="submit-btn" type="button" onClick={addData}>
                                {load ? 'Sending...' : 'Request Quote'}
                            </button>
                        </form>
                    )}

                    {formType === 'appointment' && (
                        <form className="contact-form">
                            <div className="form-group">
                                <input type="email" placeholder="Email Address *" className="form-input" required />
                            </div>
                            <div className="form-group">
                                <input type="text" placeholder="Your Name" className="form-input" />
                            </div>
                            <div className="form-group">
                                <input type="text" placeholder="Preferred Location" className="form-input" />
                            </div>
                            <div className="form-group">
                                <textarea placeholder="Purpose of Appointment..." className="form-textarea" required></textarea>
                            </div>
                            <button className="submit-btn" type="button" onClick={addData}>
                                {load ? 'Scheduling...' : 'Schedule Appointment'}
                            </button>
                        </form>
                    )}
                </div>
            </div>

            {/* Section 4: Map */}
            <div className="map-section">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d243647.34203589996!2d78.24323185623166!3d17.41228101518494!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb99daeaebd2c7%3A0xae93b78392bafbc2!2sHyderabad%2C%20Telangana!5e0!3m2!1sen!2sin!4v1728132930340!5m2!1sen!2sin"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Maviinci Location"
                ></iframe>
            </div>
        </div>
    );
};

export default ReachUs;
